import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { isAuthenticated } from '../api-handle/authService';

const PrivateRoute = () => {
  // Presence AND validity: an expired token no longer counts as logged in.
  return isAuthenticated() ? <Outlet /> : <Navigate exact to={`/login`} />;
};

export default PrivateRoute;
